var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHide({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 21.1,
    viewBox: "0 0 24 21.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.41,1.16l-1-1a.76.76,0,0,0-1.06.1l0,0L17,3.68a12.37,12.37,0,0,0-4.94-1,12.38,12.38,0,0,0-4.95,1h0A13.54,13.54,0,0,0,2.42,6.83,12.91,12.91,0,0,0,.1,10.14,1,1,0,0,0,.1,11a12.86,12.86,0,0,0,2.32,3.3,13.19,13.19,0,0,0,2.1,1.78h0L1.76,18.86A.88.88,0,0,0,1.62,20l1,1a.76.76,0,0,0,1.06-.1l0,0L22.24,2.24a.73.73,0,0,0,.21-1Zm1.31,8.58v0a1.09,1.09,0,0,0,.08.15l0,.07.09.17h0a1.72,1.72,0,0,1,.07.21h0a.85.85,0,0,1-.14.64,13.44,13.44,0,0,1-3.37,4.3l0,0a13.26,13.26,0,0,1-4,2.31l0,0a14.29,14.29,0,0,1-1.84.51h0a12.77,12.77,0,0,1-2.61.26,14.47,14.47,0,0,1-2.86-.31l0,0,2.46-2.46H12a5.06,5.06,0,0,0,5.06-5.05h0v-.43L21,6.26h0a12.63,12.63,0,0,1,2.7,3.47ZM12,7.33a3.26,3.26,0,0,0-3.26,3.25h0a3.21,3.21,0,0,0,.18,1.07L7.56,13h0a5.08,5.08,0,0,1,6.91-6.89c-.47.48-.93.93-1.38,1.37A3.31,3.31,0,0,0,12,7.32Z",
    fill: "#41319C",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHide);
export default __webpack_public_path__ + "static/media/hide.d8bae1bd766c0e163fea1151ae355b31.svg";
export { ForwardRef as ReactComponent };